<template>
  <div class="modal fade show" style="display: block">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <!-- head -->
        <div class="modal-header">
          <h5 class="modal-title">{{ getLangValue("base.preview") }}</h5>
          <button type="button" class="btn-close" @click="handleClose()"></button>
        </div>
        <div class="modal-body text-center">
          <b-img :src="src" alt="" class="rounded" :style="myWidth > 0 ? { width: `${myWidth}px` } : { width: '50rem' }"
            v-if="srcList.length == 0"></b-img>
          <div v-else style="position: relative;">
            <b-img :src="srcList[srcIndex].url" alt="" class="rounded"
              :style="myWidth > 0 ? { width: `${myWidth}px` } : { width: '50rem' }"></b-img>
            <i class="ri-arrow-left-s-line cursor-pointer"
              style="position: absolute; left: -10px; top: 50%; font-size: 30px;" v-if="srcList.length > 1"
              @click="prev"></i>
            <i class="ri-arrow-right-s-line cursor-pointer"
              style="position: absolute; right: -10px; top: 50%; font-size: 30px;" v-if="srcList.length > 1"
              @click="next"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show"></div>
</template>
<script>
import { getLangValue } from "@/utils/common"; //获取后端语言
export default {
  emits: ["update:showPreviewImg"],
  props: {
    src: String,
    showPreviewImg: {
      type: Boolean,
      default: false,
    },
    srcList: {
      type: Array,
      default: () => [],
    },
    myWidth: {
      type: Number,
      default: () => 0,
    }
  },
  data() {
    return {
      srcIndex: 0,
    }
  },
  methods: {
    getLangValue,
    handleClose() {
      this.$emit("update:showPreviewImg", false);
    },
    prev() {
      if (this.srcIndex == 0) {
        this.srcIndex = this.srcList.length - 1
      } else {
        this.srcIndex--
      }
    },
    next() {
      if (this.srcIndex == this.srcList.length - 1) {
        this.srcIndex = 0
      } else {
        this.srcIndex++
      }
    }
  },
};
</script>
<style scoped lang='scss'>
@media (min-width: 576px) {
  .modal-dialog {
    max-width: 55rem !important;
  }
}
</style>
